import MailboxForwardingConfigurationState from './schema/MailboxForwardingConfigurationState';
import { createStore } from 'satcheljs';

export default createStore<MailboxForwardingConfigurationState>('forwardingConfiguration', {
    mailboxForwardingConfiguration: null,
})();
